/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender wizard client side functions
-----------------------------------------------------------------------------*/

var TECL_Questions = {

    // Add a question
    AddQuestion: function(questionListNode, textboxNode, missingTextValNode, readOnly, showAnswerBox, isSuppliersQuestions, displayedToSupplier, tabSection, cacheId) {

        if (questionListNode && textboxNode && missingTextValNode) {
            var supplierTenderId = $("#TenderId").val();
            var parentTenderId = $("#ParentTenderId").val();

            if (supplierTenderId && parentTenderId) {
                var questionText = $(textboxNode).val();
                $(missingTextValNode).addClass("hidden");

                if (questionText && questionText.length > 0) {
                    // Get the selected suppliers
                    var supplierIds = [];
                    supplierIds.push(supplierTenderId);

                    if (TECL_Master.AddLock("TECL_Questions_AddQuestion")) {
                        $.ajax({
                            url: baseSiteUrl + "TenderUserSurface/SaveQuestion",
                            type: "POST",
                            data: {
                                parentTenderId: parentTenderId,
                                supplierTenderId: supplierTenderId,
                                questionText: questionText,
                                supplierIds: supplierIds,
                                readOnly: readOnly,
                                showAnswerBox: showAnswerBox,
                                isSuppliersQuestions: isSuppliersQuestions,
                                displayedToSupplier: displayedToSupplier,
                                tabSection: tabSection,
                                cacheId: cacheId
                            },
                            error: function() {
                                TECL_Master.ClearLock("TECL_Questions_AddQuestion");
                            },
                            success: function(questionHtml) {
                                TECL_Master.ClearLock("TECL_Questions_AddQuestion");

                                if (questionHtml) {
                                    $(questionListNode).prepend(questionHtml);
                                    $(textboxNode).val("");
                                    TECL_Master.DisplayNoticeDlg("Question sent");

                                    var upload = $("#questionFileUploader").data("kendoUpload");
                                    if (upload) {
                                        upload.clearAllFiles();
                                    }
                                } else {
                                    TECL_Master.ShowErrorDialog();
                                }
                            }
                        });
                    }
                } else {
                    $(missingTextValNode).removeClass("hidden");
                }
            }
        }
    },

    // Add an answer
    AddAnswer: function(questionId, textboxNode, missingTextValNode, questionNode, readOnly, showAnswerBox, isSuppliersQuestions, displayedToSupplier, tabSection) {
        var parentTenderId = $("#ParentTenderId").val();
        var supplierTenderId = $("#TenderId").val();

        if (parentTenderId && supplierTenderId && questionId && textboxNode && missingTextValNode && questionNode) {
            var answerText = $(textboxNode).val();
            $(missingTextValNode).addClass("hidden");

            if (answerText && answerText.length > 0) {

                if (TECL_Master.AddLock("TECL_Questions_AddAnswer")) {
                    $.ajax({
                        url: baseSiteUrl + "TenderUserSurface/SaveAnswer",
                        type: "POST",
                        data: {
                            parentTenderId: parentTenderId,
                            supplierTenderId: supplierTenderId,
                            answerText: answerText,
                            questionId: questionId,
                            readOnly: readOnly,
                            showAnswerBox: showAnswerBox,
                            isSuppliersQuestions: isSuppliersQuestions,
                            displayedToSupplier: displayedToSupplier,
                            tabSection: tabSection
                        },
                        error: function() {
                            TECL_Master.ClearLock("TECL_Questions_AddAnswer");
                        },
                        success: function(questionHtml) {
                            TECL_Master.ClearLock("TECL_Questions_AddAnswer");

                            if (questionHtml) {
                                $(questionNode).replaceWith(questionHtml);
                                TECL_Master.DisplayNoticeDlg("Answer sent");
                                TECL_Questions.OpenCloseAnswer(questionNode);
                            } else {
                                TECL_Master.ShowErrorDialog();
                            }
                        }
                    });
                }
            } else {
                $(missingTextValNode).removeClass("hidden");
            }
        }
    },

    // Open and close an answer
    OpenCloseAnswer: function(questionControlId, questionId, markAnswerAsRead) {
        var $questionCntrl = $(questionControlId);

        if ($questionCntrl) {
            var $openIcon = $questionCntrl.find("[name=openIcon]").first();
            var $closeIcon = $questionCntrl.find("[name=closeIcon]").first();
            var $answerPanel = $questionCntrl.find(".answerSection").first();
            var $questionBrandImage = $questionCntrl.find(".questionBrandImage").first();
            var $questionUnopened = $questionCntrl.find(".questionUnreadIcon").first();

            if ($answerPanel.hasClass("hidden")) {
                // Show answer
                $answerPanel.removeClass("hidden");
                $openIcon.addClass("hidden");
                $closeIcon.removeClass("hidden");
                $questionBrandImage.removeClass("hidden");
                $questionUnopened.addClass("hidden");

                if (markAnswerAsRead && questionId) {
                    TECL_Questions.MarkAnswerAsRead(questionId);
                }

            } else {
                // Hide answer
                $answerPanel.addClass("hidden");
                $openIcon.removeClass("hidden");
                $closeIcon.addClass("hidden");
                $questionBrandImage.addClass("hidden");
            }
        }
    },

    // Mark questions as read by the current user
    MarkAnswerAsRead: function(questionId) {
        if (questionId && TECL_Master.AddLock("TECL_Questions_MarkAsRead")) {
            $.ajax({
                url: baseSiteUrl + "TenderUserSurface/MarkAnswerAsRead",
                type: "POST",
                data: {
                    questionId: questionId
                },
                error: function() {
                    TECL_Master.ClearLock("TECL_Questions_MarkAsRead");
                },
                success: function(saved) {
                    TECL_Master.ClearLock("TECL_Questions_MarkAsRead");
                }
            });
        }
    },

    // Show the first tab with an unread/unanswered items on it
    ShowUnreadTab: function(tabOneHeader, tabOneContent, tabTwoHeader, tabTwoContent) {
        var $tenderTabs = $("#tenderTabs");

        if ($tenderTabs && $tenderTabs.length > 0) {

            var $tabOneContent = $tenderTabs.find("#" + tabOneContent);
            var hasUnreadItemsOne = TECL_Questions.TabHasUnreadItems($tabOneContent);

            if (!hasUnreadItemsOne) {
                var $tabTwoContent = $tenderTabs.find("#" + tabTwoContent);
                var hasUnreadItemsTwo = TECL_Questions.TabHasUnreadItems($tabTwoContent);

                if (hasUnreadItemsTwo) {
                    $("#" + tabTwoHeader + " a:first").tab("show");
                }
            }
        }
    },

    // Get whether the tab contains unread icons or unanswered icons
    TabHasUnreadItems: function($tabContent) {
        var hasUnreadItems = false;

        if ($tabContent && $tabContent.length > 0) {
            var unreadItems = $tabContent.find(".questionUnreadIcon");

            if (unreadItems && unreadItems.length > 0) {
                hasUnreadItems = true;
            } else {
                var unansweredItems = $tabContent.find(".questionUnansweredIcon");

                if (unansweredItems && unansweredItems.length > 0) {
                    hasUnreadItems = true;
                }
            }
        }
        return hasUnreadItems;
    }

};
